module.exports = __webpack_public_path__ + "static/carter-united-nations-youth-envoy-921d52dd5399def7caeac1084922930c.jpg";